import {
  // ADD_SPOT_FAILURE,
  // ADD_SPOT_LOADING,
  // ADD_SPOT_SUCCESS,
  DELETE_SPOT_FAILURE,
  DELETE_SPOT_LOADING,
  DELETE_SPOT_SUCCESS,
  FETCH_SPOT_FAILURE,
  FETCH_SPOT_LOADING,
  FETCH_SPOT_SUCCESS,
  UPDATE_SPOT_FAILURE,
  UPDATE_SPOT_LOADING,
  UPDATE_SPOT_SUCCESS
} from '../Types/spotReducer';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: true,
  item: {}
};

const spotReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_SPOT_LOADING:
    // case ADD_SPOT_LOADING:
    case UPDATE_SPOT_LOADING:
    case DELETE_SPOT_LOADING:
      return {
        ...state,
        loading: true
      };

    case FETCH_SPOT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload
      };
    // case ADD_SPOT_SUCCESS:
    //   return {
    //     ...state,
    //     data: [...state.data, action.payload],
    //     loading: false,
    //     error: null,
    //     success: 'Spot added successfully'
    //     // item: action.payload
    //   };

    case UPDATE_SPOT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map(item => (item._id === action.payload._id ? action.payload : item)),
        error: null,
        success: 'Spot updated successfully'
      };

    case DELETE_SPOT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'Spot removed successfully',
        data: state.data.filter(item => item._id !== action.payload)
      };

    case FETCH_SPOT_FAILURE:
    // case ADD_SPOT_FAILURE:
    case UPDATE_SPOT_FAILURE:
    case DELETE_SPOT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    default:
      return { ...state };
  }
};

export default spotReducer;
